import * as moment from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localeDate'
})
export class LocaleDatePipe implements PipeTransform {
  constructor() { }
  transform(value: any, dateFormat: string): string {
    moment.locale('it-IT');
    const dateLocale = moment.utc(value).local();
    return dateLocale.format(dateFormat);
  }
}
